import * as ReactDOMClient from 'react-dom/client';
import type { FC } from 'react';
import MyTeams from './Forms/MyTeams/MyTeams';
import useProfileQuery from './Utils/useProfileQuery';
import LoadingIndicator from '3-components/LoadingIndicator/LoadingIndicator';
import InlineMessage from '3-components/InlineMessage/InlineMessage';
import useSupportTeamsQuery from './Utils/useSupportTeamsQuery';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import DataList from '6-my-mcc/Components/DataList/DataList';

const Profile: FC = () => {
    const { data: profileData, isLoading: isProfileLoading, isError: isProfileError } = useProfileQuery();
    const { data: supportTeamsData, isLoading: isSupportTeamsLoading, isError: isSupportTeamsError } = useSupportTeamsQuery();

    if (isProfileLoading || isSupportTeamsLoading) {
        return (
            <LoadingIndicator className="sg-eg-loader" />
        );
    }

    if (!profileData || !supportTeamsData || isProfileError || isSupportTeamsError) {
        return (
            <InlineMessage status="error">Profile could not be retrieved.</InlineMessage>
        );
    }

    return (
        <div className="profile-wrapper">
            <MyTeams
                profileDetail={profileData.data}
                supportTeams={{
                    aflTeams: supportTeamsData.data?.aflTeams || [],
                    bblTeams: supportTeamsData.data?.bblTeams || [],
                }}
            />
            {profileData.data.specialInterests && profileData.data.specialInterests.length > 0 && (
                <div className="profile-panel">
                    <div className="profile-panel-header base-wrapper-header">
                        <h1 className="base-wrapper-title">My Clubs</h1>
                    </div>
                    <DataList>
                        {profileData.data?.specialInterests.map((item, index) => {
                            return (
                                <DataList.Item
                                    key={`my-clubs-special-interest-item-${item}-${index + 1}`}
                                    label=""
                                    value={item}
                                    hideLabel={true}
                                />
                            );
                        })}
                    </DataList>
                </div>
            )}
        </div>
    );
};

const queryClient = new QueryClient();

interface ProfileInitProps {
    el: HTMLDivElement;
}

const ProfileInit = ({ el }: ProfileInitProps): void => {
    const root = ReactDOMClient.createRoot(el);

    root.render(
        <QueryClientProvider client={queryClient}>
            <Profile />
        </QueryClientProvider>
    );
};

export default ProfileInit;
